import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { useSEO } from "@/hooks/useSEO";
import { Loader, Breadcrumbs, SectionRenderer, ModelCard, Overline, ToolLogo, Rating } from "@/components/shared";
import { NotFound } from "@/pages/ToolDetail";
import { AdSlot } from "@/components/Ads";

export default function ModelDetail() {
  const { slug } = useParams();
  const [d, setD] = useState(null);
  useEffect(() => { setD(null); api.model(slug).then(setD).catch(() => setD(false)); }, [slug]);
  useSEO(d && d.model ? { title: d.model.seo_title, description: d.model.meta_description } : {});
  if (d === false) return <NotFound />;
  if (!d) return <Loader />;
  const m = d.model;

  return (
    <div>
      <div className="klyroo-grid border-b border-white/5">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 py-10">
          <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "AI Models", to: "/ai-models" }, { label: m.name }]} />
          <div className="flex items-start gap-5">
            <ToolLogo name={m.company} logo={m.logo} size={64} />
            <div>
              <Overline>{m.company} · {m.release}</Overline>
              <h1 className="font-display text-4xl sm:text-5xl font-extrabold text-white tracking-tight mt-1">{m.name}</h1>
              <div className="flex items-center gap-4 mt-3"><Rating value={m.rating} className="text-base" /><span className="text-sm text-slate-400 font-mono">{m.model_type}</span></div>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-10">
        <div className="grid lg:grid-cols-[minmax(0,1fr)_300px] gap-8 lg:gap-10">
          <div className="min-w-0 max-w-4xl">
        <div className="grid sm:grid-cols-2 gap-3 mb-10">
          {Object.entries(m.specs).map(([k, v]) => (
            <div key={k} className="card-surface rounded-xl p-4 flex justify-between gap-3">
              <span className="text-sm text-slate-400">{k}</span>
              <span className="text-sm text-white font-medium text-right">{v}</span>
            </div>
          ))}
        </div>
        <SectionRenderer sections={m.body_sections} />
          </div>
          <aside className="lg:sticky lg:top-24 h-fit"><AdSlot placement="sidebar" /></aside>
        </div>

        <section className="mt-10">
          <h2 className="font-display text-2xl font-bold text-white mb-5 tracking-tight">Other Models</h2>
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">{d.related_models.slice(0, 6).map((x) => <ModelCard key={x.slug} m={x} />)}</div>
        </section>
      </div>
    </div>
  );
}
